import "./home.scss";
import img1 from "../../assets/home/img1.webp";
import img2 from "../../assets/home/img2.webp";
import img3 from "../../assets/home/img3.webp";
import img4 from "../../assets/home/img4.webp";
import img5 from "../../assets/home/img5.webp";
import logo from "../../assets/rmx_symbol_sm.webp";
import rmxSymbol from "../../assets/rmx symbol.png";
import { useEffect, useRef, useState } from "react";
import { gsap } from "gsap";
import Services from "../../components/services/Services";
import { FaPinterest } from "react-icons/fa";
import { FaSquareInstagram } from "react-icons/fa6";
import { FaFacebook } from "react-icons/fa6";
import { IoLogoWhatsapp } from "react-icons/io";
import { FaYoutube } from "react-icons/fa6";
import About from "../../components/about/About";
import HomeProject from "../../components/home_projects/HomeProject";
import HomeTestimonial from "../../components/home_testimonial/HomeTestimonial";
import Studio from "../../components/studio/Studio";
import { Helmet } from "react-helmet";
const Home = ({ navbarRef, mobileRef }) => {
  const textRef = useRef(null);
  const subTextRef = useRef(null);
  const imageRefs = useRef([]);
  const logoImgRef = useRef(null);

  const [currentIndex, setCurrentIndex] = useState(0);
  const IMAGE_CHANGE_DURATION = 5;
  const logoRef = useRef(null);
  const nameRef = useRef(null);

  const containerRef = useRef(null);

  const images = [
    {
      name: "RAJA VILLA",
      img: img1,
    },
    {
      name: "CHANDRA STORES",
      img: img2,
    },
    {
      name: "ELEVATE STUDIOS",
      img: img3,
    },
    {
      name: "MAYAAS HOSTEL",
      img: img4,
    },
    {
      name: "MIRACLE WEDDING",
      img: img5,
    },
  ];
  const text = "RENDER X";

  const lockScroll = () => {
    const scrollBarWidth =
      window.innerWidth - document.documentElement.clientWidth;

    document.body.style.position = "fixed";
    document.body.style.top = `-${window.scrollY}px`;
    document.body.style.width = "100%";
    document.body.style.overflowY = "scroll";
    document.body.style.paddingRight = `${scrollBarWidth}px`; // prevents jerk
  };

  const unlockScroll = () => {
    const scrollY = document.body.style.top;
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.overflowY = "";
    document.body.style.width = "";
    document.body.style.paddingRight = "";
    window.scrollTo(0, parseInt(scrollY || "0") * -1);
  };

  useEffect(() => {
    lockScroll();
    const tl = gsap.timeline({
      defaults: { ease: "power4.out" },
      onComplete: () => {
        // UNLOCK SCROLL when animation finishes
        unlockScroll();
      },
    });
    // Ensure letters can move vertically (independent of text flow)
    // Animate upward into place
    tl.fromTo(
      textRef.current,
      { y: 10, opacity: 0 }, // start position (100px down)
      { y: 0, opacity: 1, duration: 1, ease: "power2.inOut" } // end position
    );

    tl.fromTo(
      textRef.current,
      { clipPath: "inset(50% 0 50% 0)" }, // start: hidden from center
      {
        clipPath: "inset(0% 0 0% 0)", // end: fully visible
        duration: 1,
        ease: "power2.inOut",
      }
    );
    tl.to(logoRef.current, {
      duration: 1,
      ease: "power2.inOut",
      css: { mixBlendMode: "screen" },
    });

    tl.to([logoImgRef.current, logoRef.current], {
      opacity: 0,
      duration: 2,
      scale: 24,
      ease: "power2.inOut",
    });

    tl.to([logoImgRef.current, logoRef.current], {
      display: "none",
    });
    if (window.innerWidth < 768) {
      tl.to(mobileRef.current, {
        opacity: 1,
        duration: 0.2,
        ease: "power2.inOut",
      });
    }
    if (window.innerWidth >= 768) {
      tl.to(navbarRef.current, {
        opacity: 1,
        duration: 0.2,
        ease: "power2.inOut",
      });
    }
  }, []);

  useEffect(() => {
    const imgs = imageRefs.current;

    // Start with all 6idden
    gsap.set(imgs, { opacity: 0 });
    // Show only the first image initially
    gsap.set(imgs[0], { opacity: 1 });

    // Add delay so first image stays visible
    const tl = gsap.timeline({
      repeat: -1,
      repeatDelay: 0,
      delay: IMAGE_CHANGE_DURATION, // 👈 keeps the first image visible before animation starts
    });

    images.forEach((_, index) => {
      const current = imgs[index];
      const nextIndex = (index + 1) % imgs.length;
      const next = imgs[nextIndex];

      tl.to(current, {
        opacity: 0,
        duration: 1.5,
        ease: "power2.inOut",
      })
        .to(
          nameRef.current,
          {
            opacity: 0,
            duration: 1,
            ease: "power2.inOut",
          },
          "<" // starts same time as image fade-out
        )
        .to(
          next,
          {
            opacity: 1,
            duration: 1.5,
            ease: "power2.inOut",
            onStart: () => {
              // 🔥 Update name when NEXT image starts appearing

              setCurrentIndex(nextIndex);
            },
          },
          "<"
        )
        .to(
          nameRef.current,
          {
            opacity: 1,
            duration: 1,
            ease: "power2.inOut",
          },
          "<0.3" // starts slightly later for smooth effect
        )
        .to({}, { duration: IMAGE_CHANGE_DURATION });
    });
  }, []);

  return (
    <div className="home_main">
      <Helmet>
        <title>
          RenderX Architects | Architecture & Interior Design Chennai
        </title>
        <meta
          name="description"
          content="RenderX Architects is a top architecture and interior design firm in Chennai with 5+ years of experience, 100+ completed projects, and 90,000+ sq.ft. delivered."
        />

        <script type="application/ld+json">
          {`
        {
          "@context": "https://schema.org",
          "@type": "ArchitecturalFirm",
          "name": "RenderX Architects",
          "url": "https://renderxarchitects.com",
          "telephone": "+91 80561 66287",
          "email": "renderx.ch@gmail.com",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "12/16, Zackriya Colony, 1st Street, Kodambakkam, Chennai-24",
            "addressLocality": "Chennai",
            "addressRegion": "Tamil Nadu",
            "postalCode": "600094",
            "addressCountry": "IN"
          },
          "description": "Architecture and interior design company with 5+ years of experience, 100+ projects completed, and over 90,000 sq.ft. of planning and construction delivered in Chennai.",
          "foundingDate": "2020",
          "numberOfEmployees": "10-50",
          "serviceArea": "Chennai, Tamil Nadu",
          "services": [
            {
              "@type": "Service",
              "name": "Planning & Construction",
              "description": "Complete planning and construction services."
            },
            {
              "@type": "Service",
              "name": "Residential Interior Design",
              "description": "Functional, stylish residential interior solutions."
            },
            {
              "@type": "Service",
              "name": "Commercial Interior Design",
              "description": "Efficient, brand-focused commercial interior design."
            },
            {
              "@type": "Service",
              "name": "Exterior Elevation Design",
              "description": "Modern and visually striking exterior elevation design."
            }
          ],
          "keywords": [
            "Architects in Chennai",
            "Interior Design Chennai",
            "Exterior Design",
            "Residential Architecture",
            "Commercial Architects",
            "Office Space Design"
          ]
        }
        `}
        </script>
      </Helmet>
      <div className="logo_start" ref={logoImgRef}>
        <img src={logo} alt="Renderx Logo" />
      </div>
      <h1 className="logo_name" ref={logoRef}>
        <div className="logo_name_section logo_name_section1">
          <h1 ref={textRef}>
            RENDER<span className="red-letter">X</span>
          </h1>
          <h3>ARCHITECTURE & INTERIOR</h3>
        </div>
      </h1>
      <div className="home_page_container">
        {images.map((item, index) => (
          <img
            key={index}
            ref={(el) => (imageRefs.current[index] = el)}
            src={item.img}
            alt={item.name}
            className="home_carousal_image"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              // width: "99.9vw",
              // height: "99.9vh",
              objectFit: "cover",
              backgroundPosition: "center",
              opacity: 0,
            }}
          />
        ))}
        <div className="image_footer">
          <div className="footer_container">
            <div className="footer_logo">
              <div className="footer_logo_symbol_name">
                <img src={rmxSymbol} alt="Renderx Logo" />
              </div>
            </div>
            <div className="footer_social">
              <a
                href="https://www.instagram.com/renderxarchitects/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaSquareInstagram className="insta" />
              </a>
              <a
                href="https://www.facebook.com/share/1EZAnTFoQp/?mibextid=wwXIfr"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaFacebook className="facebook" />
              </a>
              <a
                href="https://wa.me/918056166287?text=Hello%2C%20I%20would%20like%20to%20know%20more%20about%20your%20services."
                target="_blank"
                rel="noopener"
              >
                <IoLogoWhatsapp className="whatsapp" />
              </a>
              <a
                href="https://youtube.com/@renderxarchitectschennai?si=Vnl9SQYRnSVRttKE"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaYoutube className="youtube" />
              </a>
              {/* <FaPinterest className="pintrest" /> */}
            </div>
            <div className="footer_info">
              <p ref={nameRef}>{images[currentIndex].name}</p>
            </div>
          </div>
        </div>
      </div>

      <div className="home_about">
        <About />
      </div>
      <div className="home_studio">
        <Studio />
      </div>
      <div className="home_services">
        <Services />
      </div>

      <div className="home_testimonials">
        <HomeTestimonial />
      </div>
      <div className="home_project">
        <HomeProject />
      </div>
    </div>
  );
};

export default Home;
